<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">
              <h1>
                {{ title }}
              </h1>
              <font-awesome-icon icon="times" @click="$emit('close')" />
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body"></slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <tol-button button-type="major" :label="submitButtonText" @click="$emit('submit')" />
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import TolButton from '@/app/components/TolButton';

export default {
  name: 'TolModal',
  components: {
    TolButton
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    submitButtonText: {
      type: String,
      default: ''
    }
  },
  methods: {
    escapeHtml(unsafe) {
      return unsafe
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $slate-grey-transparent;
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  padding: 2rem 3rem;
  background-color: #fff;
  border-radius: 0.2rem;
  box-shadow: 0 0.2rem 0.8rem $slate-grey-transparent;
  transition: all 0.3s ease;

  @media only screen and (min-width: 600px) {
    width: 50rem;
    margin: 0px auto;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  h1 {
    margin: 0;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;

    &:hover {
      background-color: $light-grey-2;
      border-radius: 0.8rem;
      cursor: pointer;
    }
  }
}

.modal-body {
  margin: 2rem 0;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
